<app-admin-custom-control [label]="label" [centerLabel]="centerLabel" [labelCols]="labelCols"
  [dividerKind]="dividerKind" [disabled]="disabled" [busy]="busy">
  <div class="input-group">
    <input type="text" [id]="'input' + uniqueId" appNumericOnly [allowNegative]="allowNegative" [decimals]="decimals"
      [appFocus]="focusInput" class="form-control" [disabled]="disabled" [ngModel]="_displayModel"
      (ngModelChange)="changeModel($event)" (click)="clickModel($event)" [placeholder]="placeholder?placeholder:''"
      autocomplete="off" [ngStyle]="style">
      <ng-content></ng-content>
  </div>
</app-admin-custom-control>